import React from 'react'
import { WithContext as ReactTags } from 'react-tag-input'
import '../css/tagbox.css'

export default class TagBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tags: [],
      suggestions: [
        '720p',
        '1080p',
        'hdlight',
        'multi',
        'truefrench',
        'bdrip',
        'brrip',
        'bluray',
        'dvdrip',
        'vostfr',
        'french',
        'vff',
        'discography',
        'flac',
        'ogg',
        'mp3',
      ],
    }
  }

  handleDelete(i) {
    let tags = this.state.tags
    tags.splice(i, 1)
    this.setState({tags: tags})
    this.props.notifyParent(this.state.tags)
  }

  handleAddition(tag) {
    let tags = this.state.tags
    tags.push({
      id: tags.length + 1,
      text: tag,
    })
    this.setState({tags: tags})
    this.props.notifyParent(this.state.tags)
  }

  handleDrag(tag, currPos, newPos) {
    let tags = this.state.tags

    // mutate array
    tags.splice(currPos, 1)
    tags.splice(newPos, 0, tag)

    // re-render
    this.setState({ tags: tags })
    this.props.notifyParent(this.state.tags)
  }

  render() {
    let tags = this.state.tags
    let suggestions = this.state.suggestions
    return (
      <ReactTags classNames={{tagInputField: 'form-control'}}
                    tags={tags}
                    suggestions={suggestions}
                    handleDelete={this.handleDelete.bind(this)}
                    handleAddition={this.handleAddition.bind(this)}
                    handleDrag={this.handleDrag.bind(this)}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/search/TagBox.js